import {makeService, modifyGroups} from './api';

const service = makeService('customers');

service.beforeCreate = function (payload) {
  return modifyGroups(payload);
};
service.beforeUpdate = function (payload) {
  return modifyGroups(payload);
};

export default service;
